import { Expose } from "class-transformer";

export class ReportSubtaskDto {
  @Expose()
  subtaskId: string;

  @Expose()
  subtaskName: string;

  @Expose()
  taskTypeId: string;

  @Expose()
  taskTypeName: string;

  @Expose()
  totalMinutes: number;
}
